import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { DatePickerField, DropDown, InputTextField } from "components/UI";
import { ModeAction } from "state/enum";
export default function CriterialSection(props) {
  const {
    mode,
    form,
    setForm,
    dataList: { exporterList, importerList, loadingPortList, dischargingPortList, orderTypeList, carFamilyCodeList },
  } = props;

  const handleChangeExporterCode = e => {
    setForm(prev => ({
      ...prev,
      exporterCd: e.target.value,
      // exporterId: e.target.value,
      // exporterCd: findObject({ data: exporterList, value: e.target.value, property: "companyId", field: "impExpCd" }),
      loadingPort: "",
    }));
  };
  const handleChangeImporterCompany = e => {
    setForm(prev => ({
      ...prev,
      importerId: e.target.value,
      dischargingPort: "",
    }));
  };
  useEffect(() => {
    document.getElementById("select-exporter-code").focus();
    return;
  }, []);
  return (
    <Grid container spacing={2}>
      {/* Container item #1 */}
      <Grid container item spacing={1} sx={{ alignItems: "center" }}>
        <Grid item xs={5} style={{ display: "flex" }}>
          <strong style={{ margin: "auto 0px", width: "325px" }}>*Exporter Code :</strong>
          <DropDown
            id="select-exporter-code"
            fullWidth
            required
            defaultValue=""
            placeholder="<Select>"
            autoFocus={true}
            value={form?.exporterCd}
            tabIndex={0}
            onChange={handleChangeExporterCode}
            menu={exporterList?.map(val => ({ key: val?.impExpCd, value: val?.impExpCd }))}
            // menu={exporterList?.map(val => ({ key: val?.companyId, value: val?.impExpCd }))}
            disabled={[ModeAction.ADD, ModeAction.EDIT].includes(mode)}
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={5} style={{ display: "flex" }}>
          <strong style={{ margin: "auto 0px", width: "325px" }}>Importer Company :</strong>
          <DropDown
            id="select-importer-code"
            fullWidth
            defaultValue=""
            placeholder="<All>"
            // value={form?.importerCd}
            value={form?.importerId}
            tabIndex={0}
            onChange={handleChangeImporterCompany}
            menu={importerList?.map(val => ({ key: val?.companyId, value: val?.companyAbbr }))}
            disabled={[ModeAction.ADD, ModeAction.EDIT].includes(mode)}
            autoFocus={true}
          />
        </Grid>
        <Grid item xs={1} />
        {/* Container item #2 */}
        <Grid item xs={5} style={{ display: "flex" }}>
          <strong style={{ margin: "auto 0px", width: "325px" }}>Loading Port :</strong>
          <DropDown
            id="select-loading-port"
            fullWidth
            defaultValue=""
            placeholder="<All>"
            value={form?.loadingPort}
            onChange={e => {
              setForm(prev => ({
                ...prev,
                loadingPort: e.target.value,
              }));
            }}
            tabIndex={0}
            menu={loadingPortList?.map(val => ({ key: val?.cd, value: val?.value }))}
            disabled={[ModeAction.ADD, ModeAction.EDIT].includes(mode)}
            autoFocus={true}
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={5} style={{ display: "flex" }}>
          <strong style={{ margin: "auto 0px", width: "325px" }}>Discharging Port :</strong>
          <DropDown
            id="select-discharging-port"
            fullWidth
            defaultValue=""
            placeholder="<All>"
            value={form?.dischargingPort}
            onChange={e => {
              setForm(prev => ({
                ...prev,
                dischargingPort: e.target.value,
              }));
            }}
            tabIndex={0}
            menu={dischargingPortList?.map(val => ({ key: val?.cd, value: val?.value }))}
            disabled={[ModeAction.ADD, ModeAction.EDIT].includes(mode)}
            autoFocus={true}
          />
        </Grid>
        <Grid item xs={1} />
        {/* Container item #3 */}
        <Grid item xs={5} style={{ display: "flex" }}>
          <strong style={{ margin: "auto 0px", width: "325px" }}>ETD :</strong>
          <DatePickerField
            id="date-etd"
            fullWidth
            value={form?.etd}
            tabIndex={0}
            onChange={date => {
              setForm(prev => ({
                ...prev,
                etd: date,
              }));
            }}
            format={"DD/MM/YYYY"}
            disabled={[ModeAction.ADD, ModeAction.EDIT].includes(mode)}
            autoFocus={true}
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={5} style={{ display: "flex" }}>
          <strong style={{ margin: "auto 0px", width: "325px" }}>Vessel Name :</strong>
          <InputTextField
            id="input-vessel-name"
            fullWidth
            value={form?.vesselName}
            onChange={e => {
              setForm(prev => ({
                ...prev,
                vesselName: e.target.value,
              }));
            }}
            tabIndex={0}
            disabled={[ModeAction.ADD, ModeAction.EDIT].includes(mode)}
            maxLength={40}
            autoFocus={true}
          />
        </Grid>
        <Grid item xs={1} />
        {/* Container item #4 */}
        <Grid item xs={5} style={{ display: "flex" }}>
          <strong style={{ margin: "auto 0px", width: "325px" }}>Order Type :</strong>
          <DropDown
            id="select-order-type"
            defaultValue=""
            placeholder="<All>"
            value={form?.orderTypeId}
            onChange={e => {
              setForm(prev => ({
                ...prev,
                orderTypeId: e.target.value,
              }));
            }}
            tabIndex={0}
            menu={orderTypeList?.map(val => ({ key: val?.cd, value: val?.value }))}
            disabled={[ModeAction.ADD, ModeAction.EDIT].includes(mode)}
            autoFocus={true}
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={5} style={{ display: "flex" }}>
          <strong style={{ margin: "auto 0px", width: "325px" }}>Car Family Code :</strong>
          <DropDown
            id="select-car-family-code"
            defaultValue=""
            placeholder="<All>"
            value={form?.carFamilyCode}
            onChange={e => {
              setForm(prev => ({
                ...prev,
                carFamilyCode: e.target.value,
              }));
            }}
            menu={carFamilyCodeList?.map(val => ({ key: val?.cd, value: val?.value }))}
            disabled={[ModeAction.ADD, ModeAction.EDIT].includes(mode)}
            autoFocus={true}
            tabIndex={0}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
